import React, { useState } from 'react'
// import { Menu, MenuItem, MenuButton, SubMenu } from '@szhsin/react-menu'
// import '@szhsin/react-menu/dist/index.css'
import styles from './index.module.scss'
import HeaderLinks from '../../components/HeaderLinks'
import Menu from '../../components/Menu'
import getVectorImage from '../../utils/getVectorImage'
import { MenuItem } from '@szhsin/react-menu'
import { useAuthState } from '../../components/AuthProvider'
import typeDisplayOptions from '../../pages/Dashboard/typeDisplayOptions'
import { useNavigate } from 'react-router-dom'
const SelectMenuList = ({
  dropdownData,
  defaultValue,
  defaultLabel,
  selectType,
  setDrillDownSelectedValueMethod,
}) => {
  const { user } = useAuthState()

  const [display] = useState('default')
  const [align] = useState('start')
  const [position] = useState('anchor')
  const [viewScroll] = useState('auto')
  const history = useNavigate()
  const [showMore, setShowMore] = useState(false)
  const [selectedValue, setSelectedValue] = useState(defaultValue)
  const [selectedLabel, setSelectedLabel] = useState(defaultLabel)

  const handleClick = (valid) => {
    setShowMore(!valid)
  }
  const handleClick2 = (value, label) => {
    if (selectType === 'drilldown') setDrillDownSelectedValueMethod(value)
    setSelectedValue(value)
    setSelectedLabel(label)
    switch (value) {
      case 'home':
       //history.pushState(null, '/Dashboardes')      
        window.location.href = "/dashboard";
        break
      case 'rsv':
          // history.pushState(null,'/RSVDashboard')
          window.location.href = "/rsvdashboard";
        break
      case 'flu':
          //  history.pushState(null,'/FluDashboard')
            window.location.href = "/fludashboard";
        break
      case 'covid':
         //  history.pushState(null,'/CovidDashboard')
           window.location.href = "/coviddashboard";
        break
      case 'vulnerability':
           //history.pushState(null,'/VulnerabilityDashboard')
           window.location.href = "/vulnerabilitydashboard";
        break
        case 'allergies':
             // history.pushState(null,'/AllergiesDashboard')
              window.location.href = "/allergiesdashboard";
          break
        case 'flunew':
          window.location.href = "/flunew";         
          break         
        
      default:
        break
    }
  }

  dropdownData =
    user.role === 'External' ? typeDisplayOptions[1] : typeDisplayOptions[0]
  return (
    <>
      <HeaderLinks>
        <>
          <HeaderLinks.Item
            label={selectedLabel}
            menuType="other"
            selectLabel={selectedLabel}
          >
            <Menu>
              {dropdownData.map((option) => {
                return (
                  <Menu.Item
                    label={option.label}
                    key={option.value}
                    onClick={(event) =>
                      handleClick2(option.value, option.label)
                    }
                    
                    menuType="other"
                    selectLabel={selectedLabel}
                  />
                )
              })}
            </Menu>
          </HeaderLinks.Item>
        </>
      </HeaderLinks>
    </>
  )
}
export default SelectMenuList
